import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { HelmetDatoCms } from "gatsby-source-datocms"

import { PageWrapper } from "components"

// Page sections
import IntroSection from "./_introSection"
import SelectorSection from "./_selectorSection"

function HowDoYouDT({ loaderComplete, isMobile }) {
  const { page, experiences } = useStaticQuery(graphql`
    {
      page: datoCmsHowDoYouDtPage {
        heroTitle
        heroImage {
          url
          width
          height
          alt
        }
        introductoryDescription
        seoMetaTags {
          ...GatsbyDatoCmsSeoMetaTags
        }
      }
      experiences: allDatoCmsExperience {
        nodes {
          url
          experience
          description
        }
      }
    }
  `)

  const [currentExperience, setCurrentExperience] = useState("")

  return (
    <>
      <HelmetDatoCms seo={page.seoMetaTags} />
      {/* ======================== HERO ======================== */}
      <PageWrapper
        id="howDoYouDT-hero"
        title={page.heroTitle}
        subtitle="How do you"
        image={page.heroImage}
        loaderComplete={loaderComplete}
        minHeight={[
          "calc((var(--vh, 1vh) * 100) - 64px - 47px)",
          "calc((var(--vh, 1vh) * 100) - 140px)",
        ]}
        page={
          <>
            {/* ======================== INTRO ======================== */}
            <IntroSection
              data={{
                bodyContent: page.introductoryDescription,
              }}
            />

            {/* ======================== SELECTOR ======================== */}
            <SelectorSection
              data={{
                experiences: experiences.nodes,
              }}
              currentExperience={currentExperience}
              setCurrentExperience={setCurrentExperience}
            />
          </>
        }
      />
    </>
  )
}

export default HowDoYouDT
